import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';

const RenderedListItemUL = forwardRef(({ isDragging = false, ...props }, ref) => {
  const draggingClass = isDragging ? '-1 border-vamos-black bg-vamos-white shadow-md' : 'border border-vamos-blue-gray';
  return (
    <li
      ref={ref}
      className={`flex justify-between items-center ${draggingClass} rounded-md h-16 mt-3 px-4 w-full`}
      {...props}
    />

  );
});

RenderedListItemUL.propTypes = {
  children: PropTypes.node.isRequired,
  isDragging: PropTypes.bool,
};

export default RenderedListItemUL;
